import { useState } from 'react';
import { Dropdown } from 'antd';
import MyFlex from '../myFlex/MyFlex';
import { ChevronRight } from 'lucide-react';
import MyLucideIcon from '../myIcon/MyLucideIcon';
import colors from '../../styles/Color.scss';

const MyDropDown = ({
  width,
  children,
  className,
  items = [],
  arrow = true,
  placement = 'bottomLeft',
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      popupRender={(menu) => <div style={{ width: width }}>{menu}</div>}
      onOpenChange={setOpen}
      placement={placement}
      arrow={false}
    >
      <MyFlex align="center" className={className || 'link_cursor'}>
        {children}
        {arrow === true ? (
          <MyLucideIcon
            strokeWidth={2}
            icon={ChevronRight}
            color={colors.whiteColor}
            style={{ transform: `rotate(${open ? -90 : 90}deg)` }}
          />
        ) : null}
      </MyFlex>
    </Dropdown>
  );
};

export default MyDropDown;
